import {IAmplitudeItemListContext} from "./get_amplitude_view_item_event_properties";
import {ITrackAmplitudeOfferSelectItemParams, trackAmplitudeOfferSelectItem} from "./track_amplitude_offer_select_item";

interface ITrackOfferSelectItemWithListContextParams {
    offer: ITrackAmplitudeOfferSelectItemParams["offer"];
    index: number;
    itemListContext?: IAmplitudeItemListContext | null;
}

export const trackOfferSelectItemWithListContext = (params: ITrackOfferSelectItemWithListContextParams) => {
    const {offer, index, itemListContext} = params;

    if (!itemListContext?.itemListId) {
        return;
    }

    trackAmplitudeOfferSelectItem({
        offer,
        index,
        itemListId: itemListContext.itemListId,
        itemListName: itemListContext.itemListName
    });
};
import {IAmplitudeItemListContext} from "./get_amplitude_view_item_event_properties";
import {ITrackAmplitudeOfferSelectItemParams, trackAmplitudeOfferSelectItem} from "./track_amplitude_offer_select_item";

interface ITrackOfferSelectItemWithListContextParams {
    offer: ITrackAmplitudeOfferSelectItemParams["offer"];
    index: number;
    itemListContext?: IAmplitudeItemListContext | null;
}

export const trackOfferSelectItemWithListContext = (params: ITrackOfferSelectItemWithListContextParams) => {
    const {offer, index, itemListContext} = params;

    if (!itemListContext?.itemListId) {
        return;
    }

    trackAmplitudeOfferSelectItem({
        offer,
        index,
        itemListId: itemListContext.itemListId,
        itemListName: itemListContext.itemListName
    });
};
